"use strict";

const $form = $('#loginForm');
const $emailInput = $('#emailInput');
const $passwordInput = $('#passwordInput');
const $submitBtn = $('#loginSubmit');
const $alert = $('#loginAlert');

const setLoading = (isLoading) => {
	$submitBtn.toggleClass('isLoading', isLoading);
	$submitBtn.prop('disabled', isLoading);
};

const showError = (message) => {
	$alert.html(message).removeAttr('hidden').addClass('shake');
	setTimeout(() => $alert.removeClass('shake'), 400);
};

const hideError = () => $alert.attr('hidden', true);

$('.toggleVisibility').on('click', function () {
	const $icon = $(this).find('.fa');
	const isPassword = $passwordInput.attr('type') === 'password';

	$passwordInput.attr('type', isPassword ? 'text' : 'password');
	$icon.toggleClass('fa-eye fa-eye-slash');
});

$form.on('submit', function (event) {
	event.preventDefault();

	const email = $emailInput.val().trim();
	const password = $passwordInput.val();

	if (email === '' || password === '') {
		showError('Please complete both fields.');
		return;
	}

	hideError();
	setLoading(true);

	fetch($form.attr('action'), {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'X-Requested-With': 'XMLHttpRequest',
			'Accept': 'application/json'
		},
		body: new URLSearchParams({ email, password })
	})
		.then((response) => response.json().then((data) => ({ ok: response.ok, data })))
		.then(({ ok, data }) => {
			if (ok && data && data.success) {
				window.location.href = data.redirect || '/lobby';
				return;
			}

			setLoading(false);
			showError((data && data.message) || 'Unable to log in. Please try again.');
			$passwordInput.val('').trigger('focus');
		})
		.catch(() => {
			// Fetch/JSON failed entirely (offline, blocked, etc) - fall back to a real submit.
			$form[0].submit();
		});
});
